<template>
  <ContactCodePrimeAffiliates
    v-if="isDeeperPrepopPrime"
    :theme="theme"
  />
  <ContactCodeAffiliates
    v-else-if="isDeeperPrepop"
    :theme="theme"
  />

  <ContactCodeStandard
    v-else
    :theme="theme"
  />
</template>

<script>
import ContactCodeStandard from '../contact-code/ContactCodeStandard.vue'
import ContactCodeAffiliates from '../contact-code/ContactCodeAffiliates.vue'
import ContactCodePrimeAffiliates from '../contact-code/ContactCodePrimeAffiliates.vue'

export default {
  name: 'ContactCode',

  // Components
  components: {
    ContactCodeStandard,
    ContactCodeAffiliates,
    ContactCodePrimeAffiliates
  },

  props: {
    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Computed
  computed: {
    isDeeperPrepop () {
      return this.$store.state.application.isDeeperPrepop
    },

    isDeeperPrepopPrime () {
      return this.$store.state.application.isDeeperPrepopPrime
    }
  }
}
</script>

<style scoped lang="scss">
</style>
